export const ORDER_CANCELLABLE = {
  contentTab: 'CANCELLABLE',
  label: 'Commandes annulables',
  filters: [
    {
      label: 'Status de commandes',
      checkedItems: [
        'RECORDED',
        'PENDING',
        'VALIDATED',
        'WAITING_SC',
        'SEND_TO_STO',
        'PREPARATION_CONFIRMED',
        'PAYMENT_PROCEED',
      ],
      path: 'status',
      defaultList: [
        'RECORDED',
        'PENDING',
        'VALIDATED',
        'WAITING_SC',
        'SEND_TO_STO',
        'PREPARATION_CONFIRMED',
        'PAYMENT_PROCEED',
      ],
      staticName: 'orderStatus',
    },
    {
      label: 'Type de contact',
      checkedItems: ['Professionnel', 'Marketplace', 'Particulier'],
      path: 'contact.store.contactType',
      staticName: 'contactType',
      defaultList: ['Professionnel', 'Marketplace', 'Particulier'],
    },
    {
      label: 'Types de commandes',
      checkedItems: ['ORDER', 'ORDER_SAV', 'INTERNAL', 'PRE_ORDER'],
      path: 'type',
      staticName: 'orderTypes',
      defaultList: ['ORDER', 'ORDER_SAV', 'INTERNAL', 'PRE_ORDER'],
    },
    {
      label: 'Marques',
      checkedItems: [],
      path: 'contact.store.brand',
      staticName: 'brand',
      defaultList: [
        'Cazeboo',
        'Home24',
        'ManoMano',
        'Hornbach',
        'Worten',
        'Amazon',
        'Leclerc',
        'Bricoman',
        'Allegro',
        'But',
        'Conforama',
        'Casanoov',
        'Brico',
        'CDiscount',
        'Kaufland',
        'XXXLutz',
        'Praxis',
        'Castorama',
        'Sicaan',
        'Bricodepot',
        'ePrice',
        'LeroyMerlin',
      ],
    },
    {
      label: 'Magasins',
      checkedItems: [],
      path: 'contact.store',
      staticName: 'stores',
      defaultList: [],
    },
  ],
  sortOptions: [
    {
      label: 'Date ↓',
      value: {
        createdAt: -1,
      },
    },
    {
      label: 'Date ↑',
      value: {
        createdAt: 1,
      },
    },
  ],
  table: [
    {
      label: 'Référence',
      code: 'REF',
      props: 'reference',
    },
    {
      label: 'Date de la commande',
      code: 'DATE',
      props: 'createdAt',
    },
    {
      label: 'Client',
      code: 'CONTACT',
      props: 'contact',
    },
    {
      label: 'Prix de la commande',
      code: 'PRICE',
      props: 'price',
    },
    {
      label: 'Statut de la commande',
      code: 'STATUS',
      props: 'status',
    },
  ],
};
